import { DataProvider } from 'react-admin'
import { throwNotSupported } from '../../../dataProvider'
import { getOrgUsers } from '../repository/getOrgUsers'
import { deleteOrgUser } from '../repository/deleteOrgUser'

const orgUsersProvider: DataProvider = {
  getList: async (_resource, params) => {
    return await getOrgUsers(params).then((response) => {
      const total = response.meta.record_count
      const data = response.data.map(parseOrgUser)

      return { data, total }
    })
  },
  getOne: throwNotSupported,
  getMany: throwNotSupported,
  getManyReference: throwNotSupported,
  update: throwNotSupported,
  updateMany: throwNotSupported,
  create: throwNotSupported,
  delete: async (_resource, params) => {
    return await deleteOrgUser(params)
  },
  deleteMany: throwNotSupported
}

const parseOrgUser = (orgUser: any) => {
  if (!orgUser) return null

  return {
    id: orgUser.id,
    'User Name':
      orgUser.attributes.first_name + ' ' + orgUser.attributes.last_name,
    'User Email': orgUser.attributes.email
  }
}

export default orgUsersProvider
